import React from 'react';
import {connect} from 'react-redux';
import Dimensions from 'react-dimensions';
import {Button, Card, Table} from 'semantic-ui-react';
import {Step, Stepper, StepLabel, StepContent} from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Tab from '../../components/tab';
import Loading from '../../components/loading';
import GA from '../../helpers/ga';
import {sendPayment, getPaymentPlans} from './actions';
import {getShopifyAppConnection} from '../dashboard-emails-page/actions';

export class WhitelabelSetupPage extends React.Component {
	constructor(props) {
		super(props);
		props.getShopifyAppConnection();

		this.state = {
			finished: false,
			stepIndex: 0
		};
	}

	componentDidMount() {
		GA.sendPageView('/dashboard/whitelabel');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.confirmationUrl && nextProps.confirmationUrl !== '' ) {
			window.location.replace(nextProps.confirmationUrl);
		}
	}

	onClickPlan = (chosenPlan, e) => {
		GA.sendEvent('/dashboard/whitelabel', 'click', 'select_plan_' + chosenPlan, 1);
		window.open('mailto:support@chated.io?subject=White Label Domain Plan Enquiry','_blank');
		// if (this.props.appConnection) {
		// 	this.props.sendPayment(this.props.appConnection, chosenPlan, config.callback_url.payment);
		// }
	}

	handleNext = () => {
		const {stepIndex} = this.state;
		this.setState({
			stepIndex: stepIndex + 1,
			finished: stepIndex >= 3
		});
	};

	handlePrev = () => {
		const {stepIndex} = this.state;
		if (stepIndex > 0) {
			this.setState({stepIndex: stepIndex - 1});
		}
	};

	renderStepActions(step) {
		const {stepIndex} = this.state;

		return (
			<div style={{margin: '12px 0'}}>
				<RaisedButton
					label={stepIndex === 3 ? 'Finish' : 'Next'}
					disableTouchRipple={true}
					disableFocusRipple={true}
					primary={true}
					onClick={this.handleNext}
					style={{marginRight: 12}}
				/>
				{step > 0 && (
					<FlatButton
						label="Back"
						disabled={stepIndex === 0}
						disableTouchRipple={true}
						disableFocusRipple={true}
						onClick={this.handlePrev}
					/>
				)}
			</div>
		);
	}

	render () {
		if (!this.props.appConnection) {
			return <Loading />;
		}

		let {stepIndex} = this.state;

		if (this.props.paid) {
			stepIndex = 3;
		}

		const paneHeight = this.props.containerHeight - 70;

		return (
			<Tab.Pane
				containerHeight={ paneHeight }
				padding={ 15 }
				headerText='Domain Verification Service'
				subHeaderText='Boost your email open rate'
			>
				<Stepper activeStep={stepIndex} orientation="vertical">
					<Step>
						<StepLabel style={{fontSize: 16}}>Learn about Domain Verification</StepLabel>
						<StepContent>
							<p style={{margin: '12px 0'}}>
								Chated.io's domain verification solution allows you to white label your domain by getting rid of the "via chated.io" message on your emails. Sending abandoned cart notification with your own email would help to increase the deliverability and open rate of notification while reduce your risk of being labelled as Spam.
							</p>

							<p style={{margin: '12px 0'}}>
								White-labelling your email is as simple as 1-2-3. Let's start setup for your white label domain by clicking "Next" button below.
							</p>
							<br />
							{this.renderStepActions(0)}
						</StepContent>
					</Step>
					<Step>
						<StepLabel style={{fontSize: 16}}>Update your DNS Settings</StepLabel>
						<StepContent>
							<p style={{margin: '12px 0 24px 0'}}>
								Go to your DNS provider and fill the CNAME settings part with the values below.
								Note: Please make sure your <span style={{fontWeight: 700}}>From Email's domain</span> matches with that of
								the DNS you're about to set.
							</p>
							<div style={{marginLeft: '12px'}}>
								<Table basic='very' fixed padded='very'>
									<Table.Header>
										<Table.Row>
											<Table.HeaderCell>CNAME</Table.HeaderCell>
											<Table.HeaderCell>Value</Table.HeaderCell>
										</Table.Row>
									</Table.Header>
									<Table.Body>
										<Table.Row>
											<Table.Cell>
												chated
											</Table.Cell>
											<Table.Cell>
												u4630803.wl054.sendgrid.net
											</Table.Cell>
										</Table.Row>
										<Table.Row>
											<Table.Cell>
												s1._domainkey
											</Table.Cell>
											<Table.Cell>
												s1.domainkey.u4630803.wl054.sendgrid.net
											</Table.Cell>
										</Table.Row>
										<Table.Row>
											<Table.Cell>
												s2._domainkey
											</Table.Cell>
											<Table.Cell>
												s2.domainkey.u4630803.wl054.sendgrid.net
											</Table.Cell>
										</Table.Row>
									</Table.Body>
								</Table>
							</div>
							{this.renderStepActions(1)}
						</StepContent>
					</Step>
					<Step>
						<StepLabel style={{fontSize: 16}}>Contact Support for verification</StepLabel>
						<StepContent>
							<p style={{margin: '12px 0 24px 0'}}>
								Once you have finished the setup, please email our support (
								<span style={{color: '#007ec0', fontWeight: 500}}>support@chated.io</span>)
								to verify your CNAME records.
							</p>
							<FlatButton
								label="Back"
								disableTouchRipple={true}
								disableFocusRipple={true}
								onClick={this.handlePrev}
							/>
						</StepContent>
					</Step>
					<Step>
						<StepLabel style={{fontSize: 16}}>FINISH!</StepLabel>
						<StepContent>
							<p style={{margin: '12px 0'}}>
								Congratulations!
							</p>
							<p style={{margin: '12px 0'}}>
								You've finished the setup for our White Label domain service. In order to ensure
								that it is setup correctly, please email our support (
								<span style={{color: '#007ec0', fontWeight: 500}}>support@chated.io</span>)
								to verify your CNAME record.
							</p>
							<p style={{margin: '12px 0'}}>
								Well then, let's start sending emails out!
							</p>
						</StepContent>
					</Step>
				</Stepper>
			</Tab.Pane>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		paid: state.callbackPaymentReducer.paid,
		appConnection: state.dashboardEmailsReducer.appConnection,
		paymentPlans: state.whitelabelReducer.paymentPlans,
		confirmationUrl: state.whitelabelReducer.confirmationUrl
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
		getShopifyAppConnection () {
			dispatch( getShopifyAppConnection() );
			dispatch( getPaymentPlans() );
		},

		sendPayment (appConnection, chosenPlan, returnUrl) {
			dispatch( sendPayment(appConnection, chosenPlan, returnUrl) );
		}
	};
}

export default connect(mapsStateToProps, mapsDispatchToProps)( Dimensions()(WhitelabelSetupPage) );



// WEBPACK FOOTER //
// ./src/containers/whitelabel-page/whitelabel-setup-page.js